import { render } from "./App.vue?vue&type=template&id=43257098"
const script = {}

import "./App.vue?vue&type=style&index=0&id=43257098&lang=scss"

import exportComponent from "C:\\Frontend\\Projects\\users-router-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__